// Colors
export const mineShaft = "#333";
export const scienceBlue = "#0351c6";
export const congressBlue = "#004b87";
export const white = "#ffffff";
export const black = "#000";
export const cloud = "#b2b2b2";
export const teal = "#6edcd2";
export const darkerteal = "#36cec1";
export const mystic = "#eef1f5";
export const alto = "#dcdcdc";
export const boulder = "#767676";
export const valhalla = "#201747";
export const milanoRed = "#b40808";
export const errorRed = "#dd1f36";
export const japaneseLaurel = "#115b05";
export const lochmara = "#008bd2";
export const success = "#115B05";
export const silver = "#ccc";
export const scorpion = "#606060";

// Font weights
export const extraLight = "100";
export const thin = "200";
export const light = "300";
export const regular = "400";
export const medium = "500";
export const semiBold = "600";
export const bold = "700";
export const darkWeight = "800";

// Headings
export const h1 = "7.2rem";
export const h2 = "6rem";
export const h3 = "4.6rem";
export const h4 = "3.2rem";
export const h5 = "2.6rem";
export const h6 = "2rem";

// Mobile Headings
export const h1m = "5rem";
export const h2m = "4.2rem";
export const h3m = "3.2rem";
export const h4m = "2.8rem";
export const h5m = "2.4rem";
export const h6m = "2rem";

// Main content width
export const mainContentWidth = "940px";

// Media Queries
export const customRetina = "360px"; //Custom, Retina
export const smallerMobile = "320px"; // Smaller devices (Such as iPhone 4, 320px and up)
export const mobile = "576px"; // Small devices (landscape phones, 576px and up)
export const tablet = "768px"; // Medium devices (tablets, 768px and up)
export const tabletLandscape = "1024px"; // tablet landscape
export const desktop = "990px"; // Small devices (laptops, 990px and up)
export const mediumDesktop = "1200px"; //  Medium devices (desktops, 1200px and up)
export const largeDesktop = "1366px"; //  Large devices (desktops, 1366px and up)
export const hdDesktop = "1920px"; // 1080p displays (large desktops, 1920px and up)
